import { setChartofAcct, fetchCoaInfo } from '../../services';
import { useAppContext } from '../../context/AppContext';
import { useState, useEffect } from 'react';

export const DefaultAccountsSettings = () => {
  const { base_url, token, showStatus } = useAppContext();
  const [accounts, setAccounts] = useState({ income: [], cogs: [], assets: [] });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [formData, setFormData] = useState({
    income: '',
    cost: '',
    asset: '',
  });

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    fetchCoaInfo(
      base_url,
      token,
      (data) => {
        if (!cancelled) {
          setAccounts(data);
          setLoading(false);
        }
      },
      (message) => {
        if (!cancelled) {
          showStatus('error', message);
          setLoading(false);
        }
      },
    );
    return () => { cancelled = true; };
  }, [base_url, token, showStatus]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    await setChartofAcct(
      base_url,
      token,
      formData,
      () => {
        showStatus('success', 'Default accounts saved successfully!');
        setSaving(false);
      },
      (message) => {
        showStatus('error', message);
        setSaving(false);
      },
    );
  };

  return (
    <div>
      <div className="step-header">
        <h2>Default Accounts for New Products</h2>
        <p>
          When Slipstream auto-creates a new product in your Accounting Software, these accounts are used
          for income, cost of goods sold, and inventory.
        </p>
      </div>

      {loading ? (
        <p className="form-hint">Loading chart of accounts…</p>
      ) : (
        <form onSubmit={handleSubmit} className="form-section">
          <div className="form-group">
            <label className="form-label" htmlFor="settings_revenue_account">Income account</label>
            <select
              id="settings_revenue_account"
              name="income"
              className="form-select"
              value={formData.income}
              onChange={(e) => setFormData(prev => ({ ...prev, income: e.target.value }))}
            >
              <option value="">Select an account</option>
              {accounts.income?.map(account => (
                <option key={account.Id} value={account.Id}>{account.Name}</option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label className="form-label" htmlFor="settings_expense_account">Cost of goods sold account</label>
            <select
              id="settings_expense_account"
              name="cost"
              className="form-select"
              value={formData.cost}
              onChange={(e) => setFormData(prev => ({ ...prev, cost: e.target.value }))}
            >
              <option value="">Select an account</option>
              {accounts.cogs?.map(account => (
                <option key={account.Id} value={account.Id}>{account.Name}</option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label className="form-label" htmlFor="settings_inventory_account">Inventory asset account</label>
            <select
              id="settings_inventory_account"
              name="asset"
              className="form-select"
              value={formData.asset}
              onChange={(e) => setFormData(prev => ({ ...prev, asset: e.target.value }))}
            >
              <option value="">Select an account</option>
              {accounts.assets?.map(account => (
                <option key={account.Id} value={account.Id}>{account.Name}</option>
              ))}
            </select>
          </div>

          <button type="submit" className="btn btn-primary" disabled={saving}>
            {saving ? 'Saving…' : 'Save Default Accounts'}
          </button>
        </form>
      )}
    </div>
  );
};
